import { z } from "zod";

const FigmaExporterProcessedStylesSchema = z.object({
  display: z
    .union([
      z.literal("block"),
      z.literal("inline-block"),
      z.literal("inline"),
      z.literal("flex"),
      z.literal("grid"),
      z.literal("none"),
    ])
    .optional(),
  position: z
    .union([z.literal("absolute"), z.literal("relative"), z.literal("fixed"), z.literal("static"), z.literal("sticky")])
    .optional(),
  top: z.string().optional(),
  right: z.string().optional(),
  bottom: z.string().optional(),
  left: z.string().optional(),
  width: z.string().optional(),
  height: z.string().optional(),
  minWidth: z.string().optional(),
  minHeight: z.string().optional(),
  maxWidth: z.string().optional(),
  maxHeight: z.string().optional(),
  zIndex: z.number().optional(),
  overflow: z
    .union([z.literal("visible"), z.literal("hidden"), z.literal("scroll"), z.literal("auto"), z.literal("clip")])
    .optional(),
  overflowX: z
    .union([z.literal("visible"), z.literal("hidden"), z.literal("scroll"), z.literal("auto"), z.literal("clip")])
    .optional(),
  overflowY: z
    .union([z.literal("visible"), z.literal("hidden"), z.literal("scroll"), z.literal("auto"), z.literal("clip")])
    .optional(),
  aspectRatio: z.string().optional(),
  flexDirection: z
    .union([z.literal("row"), z.literal("row-reverse"), z.literal("column"), z.literal("column-reverse")])
    .optional(),
  justifyContent: z
    .union([
      z.literal("flex-start"),
      z.literal("flex-end"),
      z.literal("center"),
      z.literal("space-between"),
      z.literal("space-around"),
      z.literal("space-evenly"),
    ])
    .optional(),
  alignItems: z
    .union([
      z.literal("stretch"),
      z.literal("flex-start"),
      z.literal("flex-end"),
      z.literal("center"),
      z.literal("baseline"),
    ])
    .optional(),
  alignSelf: z
    .union([
      z.literal("auto"),
      z.literal("stretch"),
      z.literal("flex-start"),
      z.literal("flex-end"),
      z.literal("center"),
      z.literal("baseline"),
    ])
    .optional(),
  flexGrow: z.number().optional(),
  flexShrink: z.number().optional(),
  flexBasis: z.string().optional(),
  flexWrap: z.union([z.literal("nowrap"), z.literal("wrap"), z.literal("wrap-reverse")]).optional(),
  gap: z.string().optional(),
  rowGap: z.string().optional(),
  columnGap: z.string().optional(),
  gridTemplateColumns: z.string().optional(),
  gridTemplateRows: z.string().optional(),
  gridColumn: z.string().optional(),
  gridRow: z.string().optional(),
  gridAutoFlow: z
    .union([
      z.literal("row"),
      z.literal("column"),
      z.literal("dense"),
      z.literal("row dense"),
      z.literal("column dense"),
    ])
    .optional(),
  alignContent: z
    .union([
      z.literal("flex-start"),
      z.literal("flex-end"),
      z.literal("center"),
      z.literal("space-between"),
      z.literal("space-around"),
      z.literal("stretch"),
    ])
    .optional(),
  padding: z.string().optional(),
  paddingTop: z.string().optional(),
  paddingRight: z.string().optional(),
  paddingBottom: z.string().optional(),
  paddingLeft: z.string().optional(),
  margin: z.string().optional(),
  marginTop: z.string().optional(),
  marginRight: z.string().optional(),
  marginBottom: z.string().optional(),
  marginLeft: z.string().optional(),
  border: z.string().optional(),
  borderWidth: z.string().optional(),
  borderStyle: z.string().optional(),
  borderColor: z.string().optional(),
  borderTop: z.string().optional(),
  borderRight: z.string().optional(),
  borderBottom: z.string().optional(),
  borderLeft: z.string().optional(),
  borderRadius: z.string().optional(),
  borderTopLeftRadius: z.string().optional(),
  borderTopRightRadius: z.string().optional(),
  borderBottomRightRadius: z.string().optional(),
  borderBottomLeftRadius: z.string().optional(),
  backgroundColor: z.string().optional(),
  backgroundImage: z.string().optional(),
  backgroundSize: z.string().optional(),
  backgroundPosition: z.string().optional(),
  backgroundRepeat: z.string().optional(),
  backgroundClip: z
    .union([z.literal("border-box"), z.literal("padding-box"), z.literal("content-box"), z.literal("text")])
    .optional(),
  backgroundOrigin: z.union([z.literal("border-box"), z.literal("padding-box"), z.literal("content-box")]).optional(),
  opacity: z.number().optional(),
  boxShadow: z.string().optional(),
  filter: z.string().optional(),
  backdropFilter: z.string().optional(),
  mixBlendMode: z
    .union([
      z.literal("normal"),
      z.literal("multiply"),
      z.literal("screen"),
      z.literal("overlay"),
      z.literal("darken"),
      z.literal("lighten"),
      z.literal("color-dodge"),
      z.literal("color-burn"),
      z.literal("hard-light"),
      z.literal("soft-light"),
      z.literal("difference"),
      z.literal("exclusion"),
      z.literal("hue"),
      z.literal("saturation"),
      z.literal("color"),
      z.literal("luminosity"),
      z.literal("plus-lighter"),
    ])
    .optional(),
  transform: z.string().optional(),
  transformOrigin: z.string().optional(),
  rotate: z.string().optional(),
  clipPath: z.string().optional(),
  color: z.string().optional(),
  fontFamily: z.string().optional(),
  fontSize: z.string().optional(),
  fontWeight: z.union([z.string(), z.number()]).optional(),
  fontStyle: z.union([z.literal("normal"), z.literal("italic"), z.literal("oblique")]).optional(),
  fontStretch: z.string().optional(),
  fontVariantCaps: z
    .union([
      z.literal("normal"),
      z.literal("small-caps"),
      z.literal("all-small-caps"),
      z.literal("petite-caps"),
      z.literal("all-petite-caps"),
      z.literal("unicase"),
      z.literal("titling-caps"),
    ])
    .optional(),
  lineHeight: z.union([z.string(), z.number()]).optional(),
  letterSpacing: z.string().optional(),
  textAlign: z
    .union([
      z.literal("left"),
      z.literal("center"),
      z.literal("right"),
      z.literal("justify"),
      z.literal("start"),
      z.literal("end"),
    ])
    .optional(),
  textDecorationLine: z
    .union([z.literal("none"), z.literal("underline"), z.literal("overline"), z.literal("line-through")])
    .optional(),
  textDecorationColor: z.string().optional(),
  textDecorationStyle: z
    .union([z.literal("solid"), z.literal("double"), z.literal("dotted"), z.literal("dashed"), z.literal("wavy")])
    .optional(),
  textDecorationThickness: z.string().optional(),
  textTransform: z
    .union([
      z.literal("none"),
      z.literal("uppercase"),
      z.literal("lowercase"),
      z.literal("capitalize"),
      z.literal("full-width"),
    ])
    .optional(),
  whiteSpace: z
    .union([
      z.literal("normal"),
      z.literal("nowrap"),
      z.literal("pre"),
      z.literal("pre-wrap"),
      z.literal("pre-line"),
      z.literal("break-spaces"),
    ])
    .optional(),
  wordBreak: z
    .union([z.literal("normal"), z.literal("break-all"), z.literal("keep-all"), z.literal("break-word")])
    .optional(),
  textOverflow: z.union([z.literal("clip"), z.literal("ellipsis")]).optional(),
  WebkitLineClamp: z.number().optional(),
  WebkitBoxOrient: z.literal("vertical").optional(),
  fontFeatureSettings: z.string().optional(),
  fill: z.string().optional(),
  stroke: z.string().optional(),
  strokeWidth: z.string().optional(),
  strokeLinecap: z.union([z.literal("butt"), z.literal("round"), z.literal("square")]).optional(),
  strokeLinejoin: z.union([z.literal("miter"), z.literal("round"), z.literal("bevel")]).optional(),
  strokeDasharray: z.string().optional(),
  strokeDashoffset: z.string().optional(),
  transition: z.string().optional(),
  animation: z.string().optional(),
  cursor: z.string().optional(),
  userSelect: z.union([z.literal("auto"), z.literal("none"), z.literal("text"), z.literal("all")]).optional(),
  pointerEvents: z
    .union([
      z.literal("auto"),
      z.literal("none"),
      z.literal("visiblePainted"),
      z.literal("visibleFill"),
      z.literal("visibleStroke"),
      z.literal("visible"),
      z.literal("painted"),
      z.literal("fill"),
      z.literal("stroke"),
      z.literal("all"),
      z.literal("inherit"),
    ])
    .optional(),
  visibility: z.union([z.literal("visible"), z.literal("hidden"), z.literal("collapse")]).optional(),
});

type ProcessedStyles = z.infer<typeof FigmaExporterProcessedStylesSchema>;

// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Schema Definitions
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---

const FigmaExporterDesignNodeTypeSchema = z.union([
  z.literal("FRAME"),
  z.literal("TEXT"),
  z.literal("SVG"),
  z.literal("COMPONENT_INSTANCE"),
]);

// Base schema without children for extension
const baseDesignNodeObjectSchema = z.object({
  id: z.string(),
  type: FigmaExporterDesignNodeTypeSchema,
  parentId: z.string().nullable(),
  styles: FigmaExporterProcessedStylesSchema.partial(),
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Individual node schemas extending the base
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---

const frameNodeObjectSchema = baseDesignNodeObjectSchema.extend({
  type: z.literal("FRAME"),
});

const textNodeObjectSchema = baseDesignNodeObjectSchema.extend({
  type: z.literal("TEXT"),
  characters: z.string(),
});

const svgNodeObjectSchema = baseDesignNodeObjectSchema.extend({
  type: z.literal("SVG"),
  svgString: z.string(),
});

const componentInstanceObjectSchema = baseDesignNodeObjectSchema.extend({
  type: z.literal("COMPONENT_INSTANCE"),
  supernovaId: z.string(),
  componentSetName: z.string(),
  componentSetDescription: z.string(),
  componentName: z.string(),
  componentDescription: z.string(),
  props: z.record(z.string(), z.union([z.string(), z.boolean()])),
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Final Node Types with children
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---

type FrameNode = z.infer<typeof frameNodeObjectSchema> & {
  children: AnyDesignNode[];
};

type TextNode = z.infer<typeof textNodeObjectSchema>;

type SvgNode = z.infer<typeof svgNodeObjectSchema>;

type ComponentInstanceNode = z.infer<typeof componentInstanceObjectSchema> & {
  children: AnyDesignNode[];
};

type AnyDesignNode = FrameNode | TextNode | SvgNode | ComponentInstanceNode;

// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Final Schemas with children
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---

const frameNodeSchema: z.ZodType<FrameNode> = z.lazy(() =>
  frameNodeObjectSchema.extend({
    children: FigmaExporterAnyDesignNodeSchema.array(),
  })
);

// Text nodes don't have children
const textNodeSchema = textNodeObjectSchema;

const svgNodeSchema: z.ZodType<SvgNode> = z.lazy(() =>
  svgNodeObjectSchema.extend({
    children: FigmaExporterAnyDesignNodeSchema.array(),
  })
);

const componentInstanceNodeSchema: z.ZodType<ComponentInstanceNode> = z.lazy(() =>
  componentInstanceObjectSchema.extend({
    children: FigmaExporterAnyDesignNodeSchema.array(),
  })
);

export const FigmaExporterAnyDesignNodeSchema = z.union([
  frameNodeSchema,
  textNodeSchema,
  svgNodeSchema,
  componentInstanceNodeSchema,
]);

// Exported types - exported like this to avoid naming conflicts and unnecessarily long names
export type FigmaExporter = {
  AnyDesignNode: AnyDesignNode;
  FrameNode: FrameNode;
  TextNode: TextNode;
  SvgNode: SvgNode;
  ComponentInstanceNode: ComponentInstanceNode;
  ProcessedStyles: ProcessedStyles;
};
